import React from 'react';
import { ArrowUpRight } from 'lucide-react';

// One line pointing to the matching SolveIT page; opens in a new tab.
export default function SolveItLink({ lead, href, children }) {
  return (
    <p className="text-[13px] text-slate-400 mt-1.5">
      {lead}{' '}
      <a href={href} target="_blank" rel="noopener"
        className="inline-flex items-center gap-0.5 text-indigo-300 underline underline-offset-2 hover:opacity-80 transition">
        {children}<ArrowUpRight className="w-3.5 h-3.5" />
      </a>
    </p>
  );
}
